export default __webpack_public_path__ + "static/media/MAIA.d09b0c3c.svg";